import {
  APP_URL_PARAM,
  B64_CODE_CHALLENGE_PARAM,
  CLIENT_ID_PARAM,
  CODE_CHALLENGE_METHOD_PARAM,
  GRANT_TYPE_PARAM,
  MFA_CODE_PARAM,
  MFA_CODE_SENT_TO_PARAM,
  MFA_FLOW_PARAM,
  MFA_TYPE_PARAM,
  REDIRECT_URI_PARAM,
  REQUESTED_PATH_PARAM,
  STATE_PARAM,
} from './Login.constants';
import { MFAFlow } from './mfa/MFA.types';
import type { AppContext, PkceParams } from './useLoginUrlContext';

interface BuildMfaUrlArgs {
  pkce: PkceParams;
  appContext: AppContext;
  mfaCode: string;
  mfaCodeSentTo: string;
  mfaType: string;
  grantType?: string | null;
}

const buildMfaUrl = ({
  pkce,
  appContext,
  mfaCode,
  mfaCodeSentTo,
  mfaType,
  grantType,
}: BuildMfaUrlArgs): string => {
  const params = new URLSearchParams();
  params.set(MFA_CODE_PARAM, mfaCode);
  params.set(MFA_CODE_SENT_TO_PARAM, mfaCodeSentTo);
  params.set(MFA_TYPE_PARAM, mfaType);
  params.set(MFA_FLOW_PARAM, MFAFlow.LOGIN);
  params.set(CLIENT_ID_PARAM, pkce.clientId);
  params.set(REDIRECT_URI_PARAM, pkce.redirectUri);
  params.set(STATE_PARAM, pkce.state);
  params.set(B64_CODE_CHALLENGE_PARAM, pkce.b64CodeChallenge);
  params.set(CODE_CHALLENGE_METHOD_PARAM, pkce.codeChallengeMethod);
  if (appContext.appUrl) {
    params.set(APP_URL_PARAM, appContext.appUrl);
  }
  if (appContext.requestedPath) {
    params.set(REQUESTED_PATH_PARAM, appContext.requestedPath);
  }
  if (grantType) {
    params.set(GRANT_TYPE_PARAM, grantType);
  }
  return `/login/mfa?${params.toString()}`;
};

export default buildMfaUrl;
